"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TinyColorUtilInstance = void 0;
var tinycolor2_1 = __importDefault(require("tinycolor2"));
// add a function to the prototype of tinycolor for conversion to THREE.Color
if (tinycolor2_1.default.prototype.toThreeColor === undefined) {
    tinycolor2_1.default.prototype.toThreeColor = function () {
        var THREEJS = require('../../externals/three');
        return new THREEJS.Color(this.toRgbString());
    };
    tinycolor2_1.default.prototype.toArray = function () {
        return [this._r, this._g, this._b, 255 * this._a];
    };
}
/**
 * __ShapeDiver 3D Viewer Application__, copyright (c) 2018 _ShapeDiver GmbH_
 *
 * *toTinyColor.js*
 *
 * ### Content
 *   * function to convert several types of string, number, and array color formats into a tinycolor object as provided by this library: https://www.npmjs.com/package/tinycolor2
 *
 * @module toTinyColor
 * @author Mathias Höbinger <mathias@shapediver.com>
 */
var TinyColorUtil = /** @class */ (function () {
    function TinyColorUtil() {
    }
    /**
     * Convert several types of string, number, and array color formats into a tinycolor object as provided by this library: https://www.npmjs.com/package/tinycolor2
     * In addition the following representations can be used:
     *   * Number[]: Array of 4 numbers in interval [0,255] (red,green,blue,alpha)
     *   * Number: Will be converted to a hex string representation and used as such, be careful when using this, ideally specify a 6 or 8 digit hex number
     *   * THREE.Color
     * This function is idempotent, it can be called on its own output and the value will stay the same.
     * @param {Object|Number|Number[]|String|THREE.Color} colorInput - input to convert to tinycolor object, may be an existing tinycolor object
     * @param {Number|String} [defaultColor] - optional default color to use, should colorInput not convert to a tinycolor object successfully. Caution: Validity of the defaultColor will not be checked.
     * @return {Object} null on error, tinycolor object as provided by https://www.npmjs.com/package/tinycolor2 on success
     */
    TinyColorUtil.prototype.toTinyColor = function (colorInput, defaultColor) {
        // check if we already got a tinycolor instance
        if (colorInput.hasOwnProperty('getOriginalInput'))
            return colorInput;
        // default color to return in case colorInput can not be parsed
        var defval = null;
        if (defaultColor) {
            defval = tinycolor2_1.default(defaultColor); // we do not check validity of defval on purpose for now!!!
        }
        // check if we got a number
        if (typeof colorInput === 'number') {
            var cs = colorInput.toString(16);
            var cl = cs.length;
            if (cl < 3)
                cs = cs.padStart(3, "0");
            else if (cl < 6)
                cs = cs.padStart(6, "0");
            else if (cl < 8)
                cs = cs.padEnd(8, "0");
            var tc_1 = tinycolor2_1.default(cs);
            return tc_1.isValid() ? tc_1 : defval;
        }
        // check if the input is a THREE.Color
        if (colorInput.isColor && typeof colorInput.getHexString == 'function') {
            var tc_2 = tinycolor2_1.default(colorInput.getHexString());
            return tc_2.isValid() ? tc_2 : defval;
        }
        // check for array of numbers
        if (Array.isArray(colorInput) && (colorInput.length == 3 || colorInput.length == 4)) {
            var isRGBArray = true;
            for (var i = 0; i < 3; ++i) {
                colorInput[i] = parseFloat(colorInput[i]);
                if (isNaN(colorInput[i])) {
                    isRGBArray = false;
                }
            }
            if (!isRGBArray)
                return defval;
            var tc_3 = tinycolor2_1.default({
                r: Math.max(0, Math.min(colorInput[0], 255)),
                g: Math.max(0, Math.min(colorInput[1], 255)),
                b: Math.max(0, Math.min(colorInput[2], 255))
            });
            if (colorInput.length == 4) {
                var a = parseFloat(colorInput[3]);
                if (!isNaN(a)) {
                    tc_3.setAlpha(Math.max(0, Math.min(a, 255)) / 255);
                }
            }
            return tc_3.isValid() ? tc_3 : defval;
        }
        // if we got something other than a string, check if
        // tinyurl can work with it
        if (typeof colorInput !== 'string') {
            var tc_4 = tinycolor2_1.default(colorInput);
            return tc_4.isValid() ? tc_4 : defval;
        }
        // tinyurl doesn't like 0x
        var tmpColor = colorInput.replace('0x', '#');
        // if we got no alpha value, add full opacity
        if (tmpColor.match(/^#[a-f0-9]{6}$/i) !== null) {
            var tc_5 = tinycolor2_1.default(tmpColor + 'ff');
            return tc_5.isValid() ? tc_5 : defval;
        }
        // standard case
        if (tmpColor.match(/^#[a-f0-9]{8}$/i) !== null) {
            var tc_6 = tinycolor2_1.default(tmpColor);
            return tc_6.isValid() ? tc_6 : defval;
        }
        // correct number which have the alpha value defined as a single hex digit
        if (tmpColor.match(/^#[a-f0-9]{7}$/i) !== null) {
            var tc_7 = tinycolor2_1.default(tmpColor.slice(0, 7) + '0' + tmpColor.slice(-1));
            return tc_7.isValid() ? tc_7 : defval;
        }
        // check if tinyurl understands the string
        var tc = tinycolor2_1.default(tmpColor);
        return tc.isValid() ? tc : defval;
    };
    ;
    return TinyColorUtil;
}());
exports.TinyColorUtilInstance = new TinyColorUtil();
